import {
  getLoanList, // 贷款列表
  getLoanDetail, // 贷款详情
  submitOrder, // 提交订单
  getIsApplyLimit,
  repeatOrderCheck
} from '@/api/loan'
import { broadcastScrollHeight } from '@/utils/broadcastScrollHeight'
import { setNumberFixed } from '@/utils/format'
const state = {
  loanList: [],
  totalCount: 0,
  loanDetail: {},
  loanDetailId: null
}

const mutations = {
  // 设置  贷款列表
  SET_LOAN_LIST: (state, { list = [] }) => {
    state.loanList = list
  },
  SET_TOTAL_COUNT: (state, count = 0) => {
    state.totalCount = count
  },
  // 设置 贷款详情
  SET_LOAN_DETAIL: (state, detail) => {
    state.loanDetail = detail
    state.loanDetail.loanType = 2 // 测试写死
  },
  SET_LOAN_DETAIL_ID: (state, id) => {
    state.loanDetailId = id
  }
}

const actions = {
  // 获取贷款列表
  async getLoanList ({ commit }, params) {
    const { pageNo, pageSize } = params
    const response = await getLoanList({ pageNo, pageSize })
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_LOAN_LIST', { list: data.result })
      commit('SET_TOTAL_COUNT', +data.totalCount)
    } else {
      commit('SET_LOAN_LIST', { list: [] })
      commit('SET_TOTAL_COUNT', 0)
    }
    // 获取列表后计算scrollHeight，告知父级
    setTimeout(broadcastScrollHeight, 0)
    return response
  },
  // 获取 贷款 详细信息
  async getLoanDetail ({ commit }, params) {
    const { id } = params
    const response = await getLoanDetail({ id })
    const { code, data } = response.data
    if (code === 0) {
      data.annualInterestRangeStart = setNumberFixed(data.annualInterestRangeStart, 2)
      data.annualInterestRangeEnd = setNumberFixed(data.annualInterestRangeEnd, 2)
      data.expectAnnualInterestRate = setNumberFixed(data.expectAnnualInterestRate, 2)
      commit('SET_LOAN_DETAIL', data)
    } else {
      commit('SET_LOAN_DETAIL', [])
    }
    // 获取详情后计算scrollHeight，告知父级
    setTimeout(broadcastScrollHeight, 0)
    return response.data
  },
  async submitOrder ({ commit }, params) {
    const response = await submitOrder(params)
    return response
  },
  async getIsApplyLimit ({ commit }, uniscid) {
    if (!uniscid) return
    const response = await getIsApplyLimit(uniscid)
    const { data } = response.data
    return data
  },
  async repeatOrderCheck({ commit }, params) {
    const response = await repeatOrderCheck(params)
    const { data } = response.data
    return data
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
